// extracted by mini-css-extract-plugin
export var dropdown = "_sg-0";
export var imageWrapper = "_sg-3";
export var itemNameContainer = "_sg-1";
export var productImage = "_sg-2";
export var spinnerWrapper = "_sg-4";